import React, { useState, useEffect } from 'react';

const weddingImages = [
  "https://images.pexels.com/photos/1128783/pexels-photo-1128783.jpeg",
  "https://images.pexels.com/photos/1721944/pexels-photo-1721944.jpeg",
  "https://images.pexels.com/photos/169190/pexels-photo-169190.jpeg",
  "https://images.pexels.com/photos/1045541/pexels-photo-1045541.jpeg",
  "https://images.pexels.com/photos/931177/pexels-photo-931177.jpeg",
  "https://images.unsplash.com/photo-1632316962873-47ee3d309f02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZGVjb3JhdGlvbnxlbnwwfHx8fDE3Njc1OTI0MjV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/313702/pexels-photo-313702.jpeg",
];

const BackgroundSlideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-advance slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      
      setTimeout(() => {
        setCurrentIndex(nextIndex);
        setNextIndex((nextIndex + 1) % weddingImages.length);
        setIsTransitioning(false);
      }, 1500); // Transition duration
      
    }, 6000); // Change image every 6 seconds

    return () => clearInterval(interval);
  }, [nextIndex]);

  // Scroll-based parallax effect
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const parallaxElements = document.querySelectorAll('.parallax-bg');
      parallaxElements.forEach((el) => {
        el.style.transform = `translateY(${scrolled * 0.3}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      {/* Current Image */}
      <div
        className={`parallax-bg absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-[1500ms] ease-in-out ${
          isTransitioning ? 'opacity-0' : 'opacity-100'
        }`}
        style={{
          backgroundImage: `url(${weddingImages[currentIndex]})`,
        }}
      />
      
      {/* Next Image (for smooth transition) */}
      <div
        className={`parallax-bg absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-[1500ms] ease-in-out ${
          isTransitioning ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          backgroundImage: `url(${weddingImages[nextIndex]})`,
        }}
      />

      {/* Elegant Overlay */}
      <div 
        className="absolute inset-0"
        style={{
          background: `linear-gradient(
            to bottom,
            rgba(250, 249, 247, 0.82) 0%,
            rgba(250, 249, 247, 0.78) 20%,
            rgba(250, 249, 247, 0.75) 40%,
            rgba(250, 249, 247, 0.78) 60%,
            rgba(250, 249, 247, 0.82) 80%,
            rgba(250, 249, 247, 0.85) 100%
          )`,
        }}
      />

      {/* Subtle texture overlay */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Soft vignette effect */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          boxShadow: 'inset 0 0 200px rgba(212, 196, 176, 0.3)',
        }}
      />
    </div>
  );
};

export default BackgroundSlideshow;
